import { ActionTree } from "vuex";
import { StudentTeachingState } from "./state";

const actions: ActionTree<StudentTeachingState, any> = {
  //
};

export default actions;
